module.exports = __webpack_public_path__ + "img/avatar-step.014c3c91.png";